import { connect } from "react-redux";
import DepositAmountForm from "../../containers/deposit/amount-form";
import { getSession } from "../../selectors";
import { Link, Redirect } from "react-router-dom";
import React from "react";
import requireAuthentication from "../../components/higher-order/require-authentication";
import Step from "../../components/step";
import Steps from "../../components/steps";

function DepositAmountPage({ session }) {
  var isIdentityVerificationEnabled = (session.get("identity_verification_enabled") === true);
  var isIdentityVerified = (session.get("identity_verified") === true);
  var identityVerificationTransactionId = session.get("identity_verification_transaction_id");
  var hasFailedIdentityVerification = (!isIdentityVerified && identityVerificationTransactionId);

  var hasNoAddress = session.getIn(["billing_address", "state"]) === null;
  var canDeposit = session.get("abilities").contains("make deposits") || hasNoAddress;
  if ((hasFailedIdentityVerification && isIdentityVerificationEnabled) || !canDeposit) {
    return <Redirect to="/tournaments" />;
  }

  return (
    <div className="l-wrapper">
      <div className="l-content l-content--80-percent">

        <Steps>
          <Step>
            Deposit Amount
          </Step>

          <Step>
            Billing Information
          </Step>

          <Step>
            Payment Method
          </Step>

          <Step>
            Deposit Confirmation
          </Step>
        </Steps>

        <h1 className="text-center">
          First Enter A Deposit Amount
        </h1>

        <DepositAmountForm />

        <div className="text-center margin-bottom--is-40">
          <Link className="link--is-white" to="/withdraw">
            Looking for withdrawal?
          </Link>
        </div>
      </div>
    </div>
  );
}

// function DisallowedDeposit({ session }) {
//   return (
//     <div className="l-wrapper">
//       <div className="l-content l-content--80-percent">

//         <h1 className="text-center">Deposit</h1>
//         <DisallowedMessage session={session} />
//       </div>
//     </div>
//   );
// }

function select(state) {
  return {
    session: getSession(state)
  };
}

export default connect(select)(requireAuthentication(DepositAmountPage));
